import { injectable } from "inversify";
import { type IService, Logger } from "@designboticteam/core";
import { createStore } from "./store";

@injectable()
class Workspace3DStoreService implements IService {
	public readonly serviceName = "Workspace3DStoreService";
	private readonly logger = new Logger(`🛠️ ${this.serviceName}`, { color: "#ffffff", backgroundColor: "#1d4ed8" });
	public readonly store = createStore();

	constructor() {
		this.logger.log("constructed");
	}

	public initialize(): void {
		this.logger.log("initialized");
	}

	public dispose(): void {}
}

export { Workspace3DStoreService };
